'use strict';

angular.module('shiftTraderApp')
  .factory('ServerUrls', ['storage', '$location', function (storage, $location) {
    var HOSTNAME_STORAGE_KEY = 'sa_overridden_hostname'
    var ENV_STORAGE_KEY = 'sa_overridden_env'
    var ServerUrls = {}

    function getBrowserHost() {
      return $location.host()
    }

    function getRootHost (hostname) {
      const subparts = hostname.split('.')
      if (subparts.length > 2) {
        subparts.shift()
      }

      return subparts.join('.')
    }

    function getBrowserPort() {
      return $location.port()
    }

    var environments = [
      {
        name: 'production',
        errorEnvironment: 'Production',
        stripeToken: 'pk_live_pZvcjmV9lqF3EEykseR6S1Wk',
        filestackKey: 'AiApsrQO9S0ytoedRKr73z',
        selected: false
      },
      {
        name: 'staging',
        errorEnvironment: 'Staging',
        stripeToken: 'pk_test_A1UJWf9nGyaWMLt3A3KL6TMj',
        filestackKey: 'AiApsrQO9S0ytoedRKr73z',
        selected: false
      },
      {
        name: 'development',
        errorEnvironment: 'Development',
        stripeToken: 'pk_test_A1UJWf9nGyaWMLt3A3KL6TMj',
        filestackKey: 'AiApsrQO9S0ytoedRKr73z',
        selected: false
      }
    ]

    var backends = [
      {
        name: 'production',
        match: [
          'shiftagent.org',
          'shiftagent.com',
          'www.shiftagent.org',
          'www.shiftagent.com',
          'test.shiftagent.org',
          'test.shiftagent.com',
          'app.shiftagent.org',
          'app.shiftagent.com',
        ],
        selected: false,
        getUrls: function(hostName, hostPort) {
          var hostMatch = lodash.find(this.match, function(host) { return host === hostName })
          var portPartial = '';

          if (hostMatch) {
            hostName = getRootHost(hostMatch)
            portPartial = (hostPort === '443' || hostPort === '80') ? '' : (':' + hostPort);
          } else {
            hostName = ServerUrls.getHostname()
          }
          return {
            railsApi: 'https://api.' + hostName + portPartial + '/v1/',
            nodeApi:  'https://api.' + hostName + portPartial + '/v1/',
            analyticsCaptureApi: 'https://analytics-capture-prod.shiftagent.org/'
          }
        }
      },
      {
        name: 'staging',
        match: [
          'shift-trader.com',
          'newstaging.shift-trader.com',
          'www.shift-trader.com',
          'test.shift-trader.com',
          'app.shift-trader.com',
        ],
        selected: false,
        getUrls: function(hostName, hostPort) {
          var hostMatch = lodash.find(this.match, function(host) { return host === hostName })
          var portPartial = '';

          if (hostMatch) {
            hostName = getRootHost(hostMatch)
            portPartial = (hostPort === '443' || hostPort === '80') ? '' : (':' + hostPort);
          } else {
            hostName = ServerUrls.getHostname()
          }
          return {
            railsApi: 'https://api.' + hostName + portPartial + '/v1/',
            nodeApi:  'https://api.' + hostName + portPartial + '/v1/',
            analyticsCaptureApi: 'https://analytics-capture-staging.shiftagent.org/'
          }
        }
      },
      {
        name: 'development',
        match: ['localhost', '127.0.0.1', '192.168'],
        selected: false,
        getUrls: function(hostName, hostPort) {
          return {
            railsApi: 'http://' + hostName + ':3000/api/v1/',
            nodeApi: 'http://' + hostName + ':3002/api/v1/',
            analyticsCaptureApi: 'http://' + hostName + ':8080/'
          }
        }
      }
    ]

    ServerUrls.current = {}

    function setBackend(backend) {
      ServerUrls.current = lodash.merge(ServerUrls.current,
        backend.getUrls(getBrowserHost(), getBrowserPort()), lodash.pick(backend, ['match', 'name']))
    }

    function setEnv(env) {
      ServerUrls.current = lodash.merge(ServerUrls.current, lodash.pick(env, ['errorEnvironment', 'stripeToken', 'filestackKey']))
    }

    var definedDomains = lodash([backends[0].match, backends[1].match])
      .flatten().map(function(hostname) { return hostname.toLowerCase() }).value()

    ServerUrls.isHostnameDefined = function(hostname) {
      return lodash.includes(definedDomains, hostname.toLowerCase())
    };

    ServerUrls.setHostname = function(hostname) {
      hostname = hostname.toLowerCase()
      storage.set(HOSTNAME_STORAGE_KEY, hostname)
    }

    ServerUrls.getHostname = function() {
      return storage.get(HOSTNAME_STORAGE_KEY)
    }

    ServerUrls.getEnv = function() {
      return storage.get(ENV_STORAGE_KEY)
    }

    ServerUrls.setEnv = function(env) {
      env = env.toLowerCase()
      storage.set(ENV_STORAGE_KEY, env)
    }

    ServerUrls.clearHostnameAndEnv = function() {
      storage.remove(ENV_STORAGE_KEY)
      storage.remove(HOSTNAME_STORAGE_KEY)
      ServerUrls.setupCurrentServer()
    }

    ServerUrls.setupCurrentServer = function() {
      var selectedBackend, selectedEnv;

      if (ServerUrls.getHostname()) {
        selectedBackend = lodash.find(backends, function(backend) {
          return lodash.includes(backend.match, ServerUrls.getHostname())
        })

        if (!selectedBackend) {
          ServerUrls.clearHostnameAndEnv()
          return
        }
        setBackend(selectedBackend)

        if (ServerUrls.getEnv()) {
          selectedEnv = lodash.find(environments, function(env) { return env.name === ServerUrls.getEnv() })

          if (!selectedEnv) {
            ServerUrls.clearHostnameAndEnv()
            return
          }

          setEnv(selectedEnv)
        } else {
          // try to find a matching ENV...
          selectedEnv = lodash.find(environments, function(env) {
            return env.name === selectedBackend.name
          })

          if (!selectedEnv) {
            ServerUrls.clearHostnameAndEnv()
            return
          }

          setEnv(selectedEnv)
        }
      } else {
        // look at the current hostname and find the correct env
        selectedBackend = lodash.find(backends, function(backend) {
          return lodash.includes(backend.match, getBrowserHost())
        })

        setBackend(selectedBackend)

        selectedEnv = lodash.find(environments, function(env) {
          return env.name === selectedBackend.name
        })

        setEnv(selectedEnv)
      }
    }

    ServerUrls.getCurrentErrorEnv = function() {
      return ServerUrls.current.errorEnvironment
    }

    ServerUrls.matchingServerHost = function() {
      var hostname = getBrowserHost()
      var idx = lodash.findIndex(backends, function(srv) {
        return lodash.includes(srv.match, hostname)
      })

      if (idx >= 0) {
        return backends[idx];
      } else {
        return undefined;
      }
    }

    ServerUrls.setupCurrentServer();

    return ServerUrls;
  }])
